<template>
	<div>
		<div class="search">
			<div class="w search-box">
				<router-link to="/" @click.native="refresh" :title='common_info.store.name'><img class="search-img" :src="common_info.store.logo" :alt='common_info.store.name' /></router-link>
				<div class="search-c">
					<div class="search-item">
						<div class="box">
							<img class="img" src="../../assets/images/search.png" alt />
							<input placeholder="搜索商品" class="search-input" type="text" v-model="searchtext" ref="searchtext" />
						</div>
						<div class="search-btn" @click="searchshop()">搜索</div>
					</div>
					<ul class="search-default" v-if="common_info.store.search_hot_open">
						<li v-for="(item,index) in common_info.store.search_hot_content" :key="index">
							<span @click="seachlist(item)" v-text="item"></span>
						</li>
					</ul>
				</div>
				<div class="cat" @click="cartgoto()">
					<img class="xia" src="../../assets/images/cat.svg" alt /> 我的购物车
					<span v-text="carnum"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['seachcon', 'catid'],
		data() {
			return {
				login: true,
				common_info: {
					store: {
						search_hot_content: {}
					}
				},
				searchtext: '', //搜索商品
				carnum: 0, //购物车数量
			}
		},
		created() {
			let that = this;
			this.common.loginType(this);
			this.common.getCommonInfo(this);
			if(!this.login){
				this.cartnumapi();
			}
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.$refs.searchtext.value) {
						that.searchshop();
					}
				}
			};
		},
		mounted() {
			this.searchtext = this.seachcon;
		},
		methods: {
			refresh() {
				this.$router.go(0);
			},
			// 购物车数量
			cartnumapi() {
				this.$api.cartnum().then(res => {
					if(res.code == 0){
						this.carnum = res.data
					}
				}).catch(err => {
					console.log(err);
				});
			},
			cartgoto() {
				this.$router.push("/cat");
			},
			seachlist(text) {
				let searconter = this.$refs.searchtext.value;
				searconter = text;
				this.searchshop(searconter);
			},
			// 搜索商品
			searchshop(textcon) {
				let searchname = this.$refs.searchtext.value;
				if (textcon) {
					searchname = textcon;
				}
				if (searchname == '') {
					this.$message({
						showClose: true,
						message: '搜索商品不可为空',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
				} else {
					let parms = {
						keyword: searchname
					}
					if (this.catid) {
						parms.id = this.catid;
					}
					this.$router.push({
						path: '/list',
						query: parms
					})

				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.search {
		height: 112px;
		background-color: #fff;
		width: 100%;

		.search-box {
			display: flex;
			height: 112px;
			padding-top: 32px;
			box-sizing: border-box;

			a {
				display: block;
				width: 187px;
				height: 55px;
			}

			.search-img {
				width: auto;
				height: auto;
				object-fit: fill;
				display: block;
				margin: 0 auto;
				max-width: 100%;
				max-height: 100%;
			}

			.search-c {
				margin-left: 113px;

				.search-item {
					display: flex;

					.box {
						width: 548px;
						height: 40px;
						border: 2px solid #ff0008;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						.img {
							height: 16px;
							width: 16px;
							margin-left: 12px;
							margin-right: 4px;
						}

						.search-input {
							width: 100%;
							height: 36px;
							// border: 0 none;
							// box-sizing: border-box;
						}
					}

					.search-btn {
						width: 90px;
						height: 40px;
						background-color: #ff0008;
						color: #fff;
						font-size: 18px;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
					}
				}

				.search-default {
					display: flex;
					margin-top: 8px;

					li {
						margin-right: 8px;
						color: #b3b3b3;

						span {
							font-size: 12px;
							color: #B3B3B3;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
							cursor: pointer;

							&:hover {
								color: #FF0E25;
							}
						}
					}
				}
			}

			.cat {
				height: 40px;
				width: 120px;
				border: 1px solid #ff0008;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #ff0008;
				box-sizing: border-box;
				margin-left: 32px;
				cursor: pointer;
				border-radius: 2px;
				position: relative;

				span {
					position: absolute;
					top: 3px;
					left: 23px;
					right: auto;
					display: inline-block;
					padding: 1px 3px;
					font-size: 12px;
					line-height: 12px;
					color: #fff;
					background-color: #e1251b;
					border-radius: 7px;
					min-width: 12px;
					text-align: center;
				}

				.xia {
					height: 18px;
					width: 18px;
					margin-right: 12px;
				}
			}
		}
	}
</style>
